// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3YcjC","content":"LoadingAlert_content__3TTOL"};